import MyStoreData from 'reducers';
import axios from 'axios'
import {FP_TERMS_CONDITION_ACCEPT, FP_DATA, FP_CHANGE_PAYMENT_VIEW, FP_DELETE_SAVED_CARD, FP_UPI, FP_SET_PAY_RESP, GET_MERCHANT_DATA,FP_DISABLE_ALL_PAYMENT_MODE, FP_SET_TRANSACTION_AMOUNT, BHARATHQR_RESPONSE } from 'actions/types'
import { removeWhiteSpaces, urlParam } from 'lib/fp-utility'
import AES256 from 'lib/aes256'
import FDConfig from 'lib/config';
import {setPayment} from "__mocks__/setPayment"

export function getMerchantData() {
    const currentState = MyStoreData.getState()
    const SessionToken = currentState.fdData && currentState.fdData.SessionToken
    const ConfigId = currentState.fdData && currentState.fdData.ConfigId
    return { SessionToken, ConfigId }
}

export async function getCardDetailInfo (cardNo){
    let cardData;

    if(cardNo && cardNo.length > 6){
        cardData =  { "cardNumber": cardNo}
        const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/getCardDetailInfo`;
        const merchantData = getMerchantData()
        const options = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json", 
                "sessionToken": merchantData.SessionToken
            },
            data: JSON.stringify(cardData),
            url: url
        }
        const result = await axios(options)
        return result
    }
        return null;
} 

export async function callCardMetaDataAPI(type, data){
    const merchantData = getMerchantData()
    let cardDATA;
    if(type==='CC'){
        cardDATA =  { "paymentMethodType": "CREDITCARD", "cardPaymentMethod": { "bin": data.card_no,"cardNumber":data.cardNumber } }
    }else if(type==='DC'){
        cardDATA =  { "paymentMethodType": "DEBITCARD", "cardPaymentMethod": { "bin": data.card_no,"cardNumber":data.cardNumber } }
    }else if(type==='IDC'){
        cardDATA = { "paymentMethodType":"IDEBIT", "cardPaymentMethod":{ "bin": data.card_no,"cardNumber":data.cardNumber } }
    }else if(type==='SC'){
        cardDATA =  { "paymentMethodType": "CREDITCARD", "cardPaymentMethod": { "bin":  data.card_no,"cardNumber":data.cardNumber } }
    }else if(type==='EMIC'){
        cardDATA = { "paymentMethodType": "EMI", "emiPaymentMethod": { "bin": data.card_no, "bankCode": data.bankcode, "bankName": data.bankname,"cardNumber":data.cardNumber } }
    }else if(type==='EMISC'){
        cardDATA =  { "paymentMethodType": "CREDITCARD", "cardPaymentMethod": { "bin":  data.card_no, "bankCode": data.bankcode, "bankName": data.bankname,"cardNumber":data.cardNumber } }
    }else if(type==='UPI'){
        cardDATA = { "paymentMethodType":"UPI", "uPIPaymentMethod": { "vpa":data } }
    }else if(type==='NB'){
        cardDATA =  { "paymentMethodType": "NETBANKING", "netbankingPaymentMethod": { "firstPayBankCode": data.firstPayBankCode ,"bankName": data.bankName }}
    }else if(type==='BHARATQR'){
        cardDATA = {"paymentMethodType":"BHARATQR"}
    }else if(type==='WALLET'){
        cardDATA =  { "paymentMethodType": "WALLET", "walletPaymentMethod": { "firstPayWalletCode": data.firstPayWalletCode ,"walletName": data.walletName }}
    }
    else if(type === "ICICIPayLater") {
        cardDATA = {"paymentMethodType" : "ICICIPAYLATER", "iciciPayLater":{"mobileNumber": data}};
    }
    else if(type === "GRABPAY"){
        cardDATA = {"paymentMethodType" : "GRABPAY"}
    }else if(type === "WECHAT"){
        cardDATA = {"paymentMethodType" : "WECHAT"}
    }else if (type === "RMS"){
        cardDATA = {"paymentMethodType" : "RMS"}
    } else if(type === "STATIC_PAYMENT"){
        cardDATA = {"paymentMethodType" : "STATIC_PAYMENT", "staticUrlParamsList":data}

    } else if(type === "CARD"){
        cardDATA =  { "paymentMethodType": "CARD", "cardPaymentMethod": { "bin": data.card_no,"cardNumber":data.cardNumber } }
    }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/getTransactionCompletionMeta`;
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json", 
            "sessionToken": merchantData.SessionToken
        },
        data: JSON.stringify(cardDATA),
        url: url
    }
    const result = await axios(options)
    return result
    // if(type === "ICICIPayLater"){
    //     const url = "https://www.mocky.io/v2/5e564dee300000590028e4fa";
    //      const options = {
    //         method: 'POST',
    //         headers: {
    //             "Content-Type": "application/json", 
    //             "sessionToken": merchantData.SessionToken
    //         },
    //         data: JSON.stringify(cardDATA),
    //         url: url
    //     }
    //     const result = await axios(options)
    //     return result
    // }else{
    //     const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/getTransactionCompletionMeta`;
    //     const options = {
    //         method: 'GET',
    //         headers: {
    //             "Content-Type": "application/json", 
    //             "sessionToken": merchantData.SessionToken
    //         },
    //         data: JSON.stringify(cardDATA),
    //         url: url
    //     }
    //     const result = await axios(options)
    //     return result
    // }
    

}

export async function callSetPaymentAPI(type, spData, txnKey, txnIv){
    const merchantData = getMerchantData()
   // const txnPublicKey = `-----BEGIN PUBLIC KEY-----\n${txnKey}\n-----END PUBLIC KEY-----`
//    console.log("PAYLOAD txnKey === ",txnKey);
//    console.log("PAYLOAD TXN",txnIv)
   // const header = { "Content-Type": "application/json", "sessionToken": merchantData.SessionToken }
      /** changes Start for GAD-11284- commerce connect change for 3DS EMV secure program change**/
    var width = window.innerWidth;
    var height = window.innerHeight; 
   const header = { "Content-Type": "application/json", "sessionToken": merchantData.SessionToken,"Browser-height": height, "Browser-width": width }
   /** changes End for GAD-11284- commerce connect change for 3DS EMV secure program change**/
    let body;
    if(type==='UPI'){
        body = setBodyData('UPI', spData);
    }else if(type==='SC'){
        body = setBodyData('CREDITCARD', spData);
    }else if(type==='NB'){
         body = setBodyData('NETBANKING', spData);
    }else if(type==='WALLET'){
        body = setBodyData('WALLET', spData); 
    }else if(type==="IDC"){
        body = setBodyData('IDEBIT', spData);
    }else if(type==="BHARATQR"){
        body = setBodyData('BHARATQR', spData);
    }else if(type==="EMIC"){ // EMI Card
        body = setBodyData('EMI', spData);
    }else if(type==='EMISC'){ // EMI Saved Card
        body = setBodyData('EMI', spData);
    }else if(type==="CC"){
        body = setBodyData('CREDITCARD', spData);
    }else if(type==="DC"){
        body = setBodyData('DEBITCARD', spData);
    }else if(type === "ICICIPayLater"){
        body = setBodyData('ICICIPayLater', spData);
    }else if(type === "CREATEOTP" || type === "VERIFYOTP"){
        body = setBodyData('ICICIPayLater', spData);
    }else if(type === "GP"){
        body = setBodyData('GRABPAY', spData);
    } else if(type == "WECHAT"){
        body = setBodyData('WECHAT', spData);
    }else if(type == "RMS"){
        body = spData
    } else if(type === 'CARD'){
        body = setBodyData('CARD', spData);
    }
    //console.log("BODY",body);

    const encryptedData = await encryptPaymentData(body, txnKey, txnIv)
        const encPayData =  { "encryptData": encryptedData }
        const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/setPaymentMethod`
        const options = {
            method: 'POST',
            headers: header,
            data: JSON.stringify(encPayData),
            url: url
        }
        const result = await axios(options);
       // console.log("RESULT",result);
        return result
    
    // const encryptedData = await encryptPaymentData(body, txnKey, txnIv)
    // const encPayData =  { "encryptData": encryptedData }
    // const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/setPaymentMethod`
    // const options = {
    //     method: 'POST',
    //     headers: header,
    //     data: JSON.stringify(encPayData),
    //     url: url
    // }
    // const result = await axios(options)
    // return result


    // if(type ==="CREATEOTP") {
    //     const encryptedData = await encryptPaymentData(body, txnKey, txnIv);
    //     const encPayData =  { "encryptData": encryptedData };
    //     const url =   "https://www.mocky.io/v2/5e564c7f300000580028e4d5";
    //     const options = {
    //         method: 'GET',
    //         headers: header,
    //         data: JSON.stringify(encPayData),
    //         url: url
    //     }
    //     const result = await axios(options);
    //     return result;
    // }
    // if(type === "VERIFYOTP"){
    //     const encryptedData = await encryptPaymentData(body, txnKey, txnIv);
    //     const encPayData =  { "encryptData": encryptedData };
    //     const url =   " https://www.mocky.io/v2/5e564cb0300000355b28e4dc";
    //     const options = {
    //         method: 'GET',
    //         headers: header,
    //         data: JSON.stringify(encPayData),
    //         url: url
    //     }
    //     const result = await axios(options);
    //     return result;
    // }
    // if(type === "ICICIPayLater" && type !=  "CREATEOTP" && type != "VERIFYOTP"){
    //     const encryptedData = await encryptPaymentData(body, txnKey, txnIv);
    //     const encPayData =  { "encryptData": encryptedData };
    //     const url =   "https://www.mocky.io/v2/5e564c133000005b0028e4cc";
    //     const options = {
    //         method: 'GET',
    //         headers: header,
    //         data: JSON.stringify(encPayData),
    //         url: url
    //     }
    //     const result = await axios(options);
    //     return result;

    // }else{
    //     const encryptedData = await encryptPaymentData(body, txnKey, txnIv)
    //     const encPayData =  { "encryptData": encryptedData }
    //     const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/setPaymentMethod`
    //     const options = {
    //         method: 'POST',
    //         headers: header,
    //         data: JSON.stringify(encPayData),
    //         url: url
    //     }
    //     const result = await axios(options)
    //     return result
    // }
    

}

const encryptPaymentData = (objData, txnKey, txnIv) => {
    const encrypt_result = AES256.encrypt(JSON.stringify(objData), txnKey, txnIv)
    return encrypt_result
}

const setBodyData = (type, objData) => {
    let body =  { "transactionDetails": { "transactionType": "SALE","paymentMethod": type } }
    /* Static Parameters - commented because we don't know the use case for this flags */
    // body =  { ...body, "recurringTransaction": false, "vaultedPayment": false }

    if(type === "ICICIPayLater"){
        body = {...body, "iciciPayLaterBean": objData} 
    }
    if(type==='UPI'){
        body = { ...body, "uPIPaymentMethod": { "vpa": objData } }
    }

    if(type==='NETBANKING'){
        body = { ...body, "bankData":{ "firstPayBankCode": objData.firstPayBankCode, "bankName": objData.bankName } }
    }

    if(type==='WALLET'){
        body = { ...body, "walletPaymentMethod":{ "firstPayWalletCode": objData.firstPayWalletCode, "walletName": objData.walletName } }
    }

    if(objData && objData.cardForm){
        if(objData.cardForm.DCCSelected){
            body = { ...body, "dCCSelected": objData.cardForm.DCCSelected===FDConfig.exchangeCurrencyLabel }
        }
        if(objData.cardForm.card){
            body =  { ...body, "cardData": { ...objData.cardForm.card, cardNumber: removeWhiteSpaces(objData.cardForm.card.cardNumber) } }
            body = setSIPayload(body, objData.cardForm)
        }
        if(objData.cardForm.emiTenure){
            body =  { ...body, "emiTenure": objData.cardForm.emiTenure }
        }
    }

    if(objData && objData.sc){
        body = { ...body, "cardData": { "cVV": objData.sc.cvv }, "hostedId": objData.sc.hostedId, "vaultedPayment": true }
        body = setSIPayload(body, objData)
        if(objData.sc.DCCSelected){
            body = { ...body, "dCCSelected": objData.sc.DCCSelected===FDConfig.exchangeCurrencyLabel }
        }
        if(objData.sc.emiTenure){
            body =  { ...body, "emiTenure": objData.sc.emiTenure }
        }
    }

    if(objData && objData.selectedBank){
        body = { ...body, "bankData": { "firstPayBankCode": objData.selectedBank.firstPayBankCode, "bankName": objData.selectedBank.bankName } }
    }

    if(objData && objData.cardForm &&  objData.cardForm.card && objData.cardForm.cardScheme === "UNIONPAY"){
        body = { ...body, "cupCardBean":{...objData.cardForm.cupCardBean}}
    }
    return body
}

const setSIPayload = (body, data) => {
    if(data.standingInstruction){
        // TODO - Need to enable this code if we don't need to send sIAmtType if type if 'Fixed'
        // let newSIInst = data.standingInst
        // if(newSIInst.sIAmtType==="Fixed"){
        //     const { maxDebitAmt, ...newSIInstData } = data.standingInst;
        //     newSIInst = newSIInstData
        // }
        return {...body, autoDebit:data.autoDebit, standingInstruction: data.standingInstruction, standingInstructionData: {...data.standingInst}}
    }else{
        return {...body}
    }
}

export async function callSetPayment(type, card, txnKey, txnIv){
    const result = await callSetPaymentAPI(type, card, txnKey, txnIv)
    if(type === 'BHARATQR')
    return { payload: result, type: BHARATHQR_RESPONSE, actionFrom: type}
    
    return {payload: result, type: FP_SET_PAY_RESP, actionFrom: type}
}

export function toggleTermsAndCondition(termsStatus){
    return {payload :{termsStatus}, type:FP_TERMS_CONDITION_ACCEPT  }
}

export async function callDeleteSavedCard(card_id, merchantId){
    const merchantData = getMerchantData()
    const cardDATA =  { "hostedId": card_id, 'merchantID': merchantId }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/deleteVaultedCard`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json", 
            "sessionToken": merchantData.SessionToken
        },
        data: JSON.stringify(cardDATA),
        url: url
    }
    const result = axios(options)
    return {payload: result, type: FP_DELETE_SAVED_CARD}
}

export function redirectToCancelUrl(){
    const merchantData = getMerchantData()
    let getRazorAPIPayload = {
        sessionTokenId: merchantData.SessionToken
    }
    razorPayURLRedirect(FDConfig.razor_pay_cancel, getRazorAPIPayload)
}

export async function invalidateSession(){
    const merchantData = getMerchantData()
    const apiDATA =  { sessionToken: merchantData.SessionToken }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/invalidateSession?sessionToken=${merchantData.SessionToken}`
    const options = {
        method: 'GET',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(apiDATA),
        url: url
    }
    const result = await axios(options)
    return result
}

export function callResendOTPAPI(){
    const merchantData = getMerchantData()
    const apiDATA =  { sessionToken: merchantData.SessionToken }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/resendCardOtp`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(apiDATA),
        url: url
    }
    const result = axios(options)
    return result
}

export function callRedirectToACSAPI(){
    const merchantData = getMerchantData()
    const apiDATA =  { sessionToken: merchantData.SessionToken }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/redirectToACSUrl`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(apiDATA),
        url: url
    }
    const result = axios(options)
    return result
}

export async function callVPAResponse(vpa_no, txnKey, txnIv){
    const metaResult = await callCardMetaDataAPI('UPI', vpa_no )
    const result = await callSetPaymentAPI('UPI', vpa_no, txnKey, txnIv)
    return {payload: result, type: FP_UPI}
}

export async function callGetTxnStatus(vpa_data){
    const cardDATA = { "fpTransactionId" : vpa_data.fpTransactionId, "merchantId" : vpa_data.merchantId,"inquiryNo":vpa_data.inquiryNo}
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/getTxnStatus`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json", 
            "sessionToken": vpa_data.sessionToken
        },
        data: JSON.stringify(cardDATA),
        url: url
    }
    const result = await axios(options).then(function(data){
        return data.data;
    })
    return {payload: result, type: FP_DELETE_SAVED_CARD}
}

export function changePaymentView(selectedPayment){
    return {payload: {selectedPayment}, type: FP_CHANGE_PAYMENT_VIEW }
}

export function disableAllPaymentView(toggle){
    return {payload:{disableAllPaymentMode:toggle},type :FP_DISABLE_ALL_PAYMENT_MODE}
}


const loadExternalScript = (checkoutjs, razorpayjs) => {
    let promise = new Promise( (resolve, reject) => {
        let checkout_script = document.createElement("script");
        checkout_script.async = "async";
        checkout_script.type = "text/javascript";
        checkout_script.src = checkoutjs;
        checkout_script.onload = checkout_script.onreadystatechange = function(_, isAbort) {
            if (!script.readyState || /loaded|complete/.test(checkout_script.readyState)) {
                if (isAbort)
                reject("checkoutjs Script not loaded");
                else
                resolve("checkoutjs Script loaded");
            }
        };

        let script = document.createElement("script");
        script.async = "async";
        script.type = "text/javascript";
        script.src = razorpayjs;
        script.onload = script.onreadystatechange = function(_, isAbort) {
            if (!script.readyState || /loaded|complete/.test(script.readyState)) {
                if (isAbort)
                reject("Razorpay Script not loaded");
                else
                resolve("Razorpay Script loaded");
            }
        };

        script.onerror = function() {
            reject("Script not loaded...");
        };

        document.head.appendChild(script);
    })
    return promise
  };

export const RedirectRazorPaySubmit = function(razorPayOrderResponseBean){
    let promise = new Promise( (resolve, reject) => {
        const checkoutjs = "https://checkout.razorpay.com/v1/checkout.js"
        const razorpayjs = "https://checkout.razorpay.com/v1/razorpay.js"
        loadExternalScript(checkoutjs, razorpayjs).then(function(mydata){
            const amt = razorPayOrderResponseBean.amount;	
            const orderId = razorPayOrderResponseBean.id;
            const sessionTokenId = razorPayOrderResponseBean.sessionTokenId;
            const card = razorPayOrderResponseBean.card;
            let data;
            let getRazorPayload;
            const razorpay = new window.Razorpay({
                key: razorPayOrderResponseBean.key,
                account_id: razorPayOrderResponseBean.account_id,
                // logo, we'll display it in payment processing popup
                image: razorPayOrderResponseBean.imageLogo,
            });
            if( razorPayOrderResponseBean.method === 'NETBANKING'){
                data = {
                    amount: amt,
                    email: razorPayOrderResponseBean.email,
                    contact: razorPayOrderResponseBean.contact,
                    notes: razorPayOrderResponseBean.notes,
                    order_id: razorPayOrderResponseBean.id,
                    method: 'netbanking',
                    bank: razorPayOrderResponseBean.bank
                }
            }else if( razorPayOrderResponseBean.method === 'WALLET'){
                data = {
                    amount: amt,
                    email: razorPayOrderResponseBean.email,
                    contact: razorPayOrderResponseBean.contact,
                    notes: razorPayOrderResponseBean.notes,
                    order_id: razorPayOrderResponseBean.id,
                    method: 'wallet',
                    wallet: razorPayOrderResponseBean.wallet
                }; 
            }
            else if( razorPayOrderResponseBean.method === 'CARD'){
                data = {
                    amount:amt,
                    email:razorPayOrderResponseBean.email,
                    contact:razorPayOrderResponseBean.contact,
                    notes:razorPayOrderResponseBean.notes,
                    order_id:razorPayOrderResponseBean.id,
                    method:"card",
                    card:{
                        number: card.number,
                        cvv:card.cvv,
                        expiry_month: card.expiry_month,
                        expiry_year:card.expiry_year,
                        name:card.name

                    } 

                }
            }
            razorpay.createPayment(data);
            razorpay.on('payment.success', function(resp) {
               resolve({formUrl: FDConfig.razor_pay_success, paymentId: resp.razorpay_payment_id,orderId: orderId, sessionTokenId: sessionTokenId});
            })
            razorpay.on('payment.error', function(resp){      
                resolve({formUrl: FDConfig.razor_pay_failure, orderId: orderId, responseError: resp.error.description, sessionTokenId: sessionTokenId});
            })
        })
    });
    return promise
}

function razorPayURLRedirect(razorPayType, razorPayData){
    let formatURL;
    const { sessionTokenId } = razorPayData;

    if((razorPayType >= 0) && (razorPayType === 2))
    {
        formatURL = `${FDConfig.go_cancel_payment}?sessionToken=${sessionTokenId}`
        window.open(formatURL, "_self")
    }
}

export async function getEMIBankAndOptionsList(selectedEmiBank=null){
    const merchantData = getMerchantData()
    let reqDATA = { "paymentMethod": "EMI", "reqType": 1 }
    if(selectedEmiBank){
        reqDATA = { ...reqDATA, "reqType": 2, "bankCode": selectedEmiBank.bankcode, "bankName": selectedEmiBank.bankname ,"emitype":selectedEmiBank.emitype ,"emiindicator":selectedEmiBank.emiindicator}
    }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/EmiPaymentApiInterfaceS2s`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json", 
            "sessionToken": merchantData.SessionToken
        },
        data: JSON.stringify(reqDATA),
        url: url
    }
    const result = await axios(options).then(function(data){
        return data.data;
    })
    return result
}

export function callInitCall(){
    const merchantData = getMerchantData()
    const initDATA =  {"MRCT_TNC":"Y", "configId": merchantData.ConfigId, "paymentMethodType": "CREDITCARD" }
    const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/init`
    const options = {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            "sessionToken": merchantData.SessionToken
        },
        data: JSON.stringify(initDATA),
        url: url
    }
    const result = axios(options);
    return {payload: result, type: FP_DATA}
}

export function getMerchantDataFromReq(){
    const SessionToken = urlParam('sessionToken')
    const ConfigId = urlParam('configId')
    const lang = urlParam('lng')
    const payload = { SessionToken, ConfigId, lang }
    return { payload, type: GET_MERCHANT_DATA}
}

export function setTransactionAmount(amount){
    return { payload: { amount }, type : FP_SET_TRANSACTION_AMOUNT}
}